import { createContext } from "react";
const ClipContext = /*#__PURE__*/createContext();
export default ClipContext;
//# sourceMappingURL=ClipContext.js.map